import { Component, OnInit, ChangeDetectorRef, AfterViewInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';

import { Observable } from 'rxjs/Observable';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';

import { AuthService } from '../shared/auth.service';
import { IUserCredentials } from '../shared/shared.interface';


@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  loginForm: FormGroup;
  loginProgress: string = '';
  signedIn: boolean = false;
  googleAuth: any;

  loading: BehaviorSubject<boolean> = new BehaviorSubject(false);
  loading$: Observable<boolean> = this.loading.asObservable();

  constructor(
    private authService: AuthService,
    private _fb: FormBuilder,
    private changeDetector: ChangeDetectorRef,
    public router: Router
  ) { }

  ngOnInit() {
    this.loginForm = this._fb.group({email: ['', Validators.required], password: ['', Validators.required]});

    if (localStorage.getItem('yoola_app:token')) {this.router.navigate(['']);} else {
      this.authService.init_google_auth_system().subscribe((googleAuth) => {
        this.googleAuth = googleAuth;
        this.changeDetector.detectChanges();
      });
    }
  }

  login() {
    if (this.loginForm && this.loginForm.valid) {
      const credentials = this.loginForm.value;
      this.loading.next(true);
      this.loginProgress = '';
      this.authService.login('credentials', credentials).subscribe((res: boolean) => {
          if (res) {
            this.loading.next(false);
            this.signedIn = true;
            this.router.navigate(['']);
          }
      }, err => {
          this.loading.next(false);
          this.processError(err.status);
      });
    }
  }

  googleLogin(uxMode = 'popup') {
    this.loading.next(true);
    this.googleAuth.signIn({ ux_mode: uxMode})
    .then(() => {
        const googleUser = this.googleAuth.currentUser.get();
        const idToken = googleUser.getAuthResponse().id_token;
        // const idToken = googleUser.getAuthResponse().access_token;
        this.authService.send_google_token(idToken).subscribe((uc: IUserCredentials) => {
            this.authService.save_credentials(uc);
            this.loading.next(false);
            this.signedIn = true;
            this.googleAuth.disconnect();
            location.assign('');
        }, err => {
            this.googleAuth.disconnect().then(() => {
              this.loading.next(false);
              this.processError(err.status);
              this.changeDetector.detectChanges();
            });
        });
    }, (err) => {
      this.loading.next(false);
      if (err.error === 'popup_closed_by_user') location.reload(); else console.log(err);
    });
  }

  private processError(errorStatus) {
    switch (errorStatus) {
      case 403: this.loginProgress = 'Sign in forbidden'; break;
      case 404: this.loginProgress = 'Email or password is wrong'; break;
      default: this.loginProgress = 'Unknown Error with Sign In';
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/login/login.component.ts